export const TST_FREE_DATA = 'TST_FREE_DATA'

export const TST_SET_TESTS_LOADING_STATE = 'TST_SET_TESTS_LOADING_STATE'
export const TST_GET_CURRENT_TEST = 'TST_GET_CURRENT_TEST'

export const TST_CLEAR_TESTS_LIST = 'TST_CLEAR_TESTS_LIST' // Очистка списка запросов на КП
export const TST_GET_TESTS_LIST = 'TST_GET_TESTS_LIST' // Получение списка запросов на КП, согласно установленному текущему фильтру
export const TST_GET_USERS = 'TST_GET_USERS' //
export const TST_ADD_USER = 'TST_ADD_USER' //
export const TST_DEL_USER = 'TST_DEL_USER' //

export const TST_POST_TEST = 'TST_POST_TEST' // Изменение состояния запроса
export const TST_ADD_FILE = 'TST_ADD_FILE' // Добавление файла к запросу
export const TST_DEL_FILE = 'TST_DEL_FILE' // Удаление файла из запроса
export const TST_CHANGE_COMMENT = 'TST_CHANGE_COMMENT' // Добавление/обновление комментария
export const TST_DELETE_COMMENT = 'TST_DELETE_COMMENT' // Удаление комментария

export const TST_SET_TIME = 'TST_SET_TIME' //
export const TST_SET_TESTS_FILTER = 'TST_SET_TESTS_FILTER' // Установка текущего фильтра на статус обращений, входящих в список
export const TST_SET_TESTS_TYPE_FILTER = 'TST_SET_TESTS_TYPE_FILTER' // Установка текущего фильтра на статус обращений, входящих в список
export const TST_GET_TEST_STATUS_LIST = 'TST_GET_TEST_STATUS_LIST'
export const TST_GET_TEST_TYPES_LIST = 'TST_GET_TEST_TYPES_LIST'
export const TST_SET_CURRENT_TEST = 'TST_SET_CURRENT_TEST'
export const TST_CREATE_TEST = 'TST_CREATE_TEST' // Создание нового теста (аттестации)
export const TST_CANCEL_TEST = 'TST_CANCEL_TEST' // Удалить тест (аттестацию)

export const TST_ADD_QUESTION = 'TST_ADD_QUESTION' // Добавление вопроса в тест
export const TST_UPD_QUESTION = 'TST_UPD_QUESTION' // Обновление вопроса в тесте
export const TST_DEL_QUESTION = 'TST_DEL_QUESTION' // Удаление вопроса из теста
export const TST_SET_CURRENT_Q = 'TST_SET_CURRENT_Q'

export const TST_ADD_ANSWER = 'TST_ADD_ANSWER' // Добавление ответа в вопрос
export const TST_UPD_ANSWER = 'TST_UPD_ANSWER' // Обновление ответа в вопросе
export const TST_DEL_ANSWER = 'TST_DEL_ANSWER' // Удаление ответа из вопроса
export const TST_SET_CURRENT_A = 'TST_SET_CURRENT_A'

export const TST_SET_ANSWERS = 'TST_SET_ANSWERS' // Ответ в вопрос, сотрудник
export const TST_GET_REST = 'TST_GET_REST' //
export const TST_GET_ACTIONS = 'TST_GET_ACTIONS' //
